<div class="step-content">
    <div class="step-header">
        <h2 class="step-title">Paso 2: Tipo & Público</h2>
    </div>

    <form [formGroup]="form">
        <div class="form-group">
            <label class="form-label">¿Qué estás creando?</label>
            <div class="option-cards">
                @for (item of functionalTypeOptions; track $index) {
                <div class="option-card" [class.selected]="form.get('functionalTypeId')?.value === item.id"
                    (click)="!isReadonly && selectType(item.id)">
                    <div class="option-icon">
                        <i class="fa" [ngClass]="item.code" style="font-size: 32px; color: #f59e0b"></i>
                    </div>
                    <h4 class="option-title">{{ item.text }}</h4>
                    <p class="option-description">{{ item.description }}</p>
                </div>
                }
            </div>
        </div>
        
        @if (form.get('functionalTypeId')?.value === functionalType.Service) {
        <div class="form-group">
            <label [class.required-field]="!isReadonly">Selecciona un servicio</label>
            @if (!isReadonly) {
            <div>
                <app-dropdown [options]="availableServicesOptions" formControlName="serviceId"></app-dropdown>
                @if (
                form.get('serviceId')?.invalid &&
                (form.get('serviceId')?.touched || form.get('serviceId')?.dirty)
                ) {
                @if (form.get('serviceId')?.errors?.['required'] == true) {
                <div class="invalid-field">Este campo es requerido</div>
                }
                }
            </div>
            } @else {
            <p class="form-control-plaintext">
                {{form.get('service')?.value}}
            </p>
            }
        </div>
        }

        <!-- Checkboxes -->
        <div class="form-group">
            <label class="form-label">¿Para quién es este producto/servicio?</label>
            @if (!isReadonly) {
            <div class="checkbox-group">
                <label class="checkbox-item">
                    <input type="checkbox" formControlName="eligibleCompany" />
                    <span class="checkmark"></span>
                    Empresa
                </label>
                <label class="checkbox-item">
                    <input type="checkbox" formControlName="eligibleCandidate" />
                    <span class="checkmark"></span>
                    Candidato
                </label>
                <label class="checkbox-item">
                    <input type="checkbox" formControlName="eligibleFreelance" />
                    <span class="checkmark"></span>
                    Independiente
                </label>
            </div>

            @if (form.errors?.['atLeastOne'] && form.touched) {
            <div class="invalid-field">
                Debes seleccionar al menos una opción (Empresa, Candidato o Independiente)
            </div>
            }
            } @else {
            <ul class="list-unstyled mb-0">
                @if (form.get('eligibleCompany')?.value) {
                <li>✔ Empresa</li>
                }
                @if (form.get('eligibleCandidate')?.value) {
                <li>✔ Candidato</li>
                }
                @if (form.get('eligibleFreelance')?.value) {
                <li>✔ Independiente</li>
                }
                @if (
                !form.get('eligibleCompany')?.value &&
                !form.get('eligibleCandidate')?.value &&
                !form.get('eligibleFreelance')?.value
                ) {
                <li>—</li>
                }
            </ul>
            }
        </div>
    </form>
</div>